// RHF хранит resolver-возвращаемые ошибки плоско (errors['root.0']),
// а form.setError('root.server') — вложенно (errors.root.server). Тип
// верхушки тоже разный (есть message — лист; нет — ветка). Эта функция
// рекурсивно собирает все .message из всех root-* / root.* веток.
export function collectRootMessages(errors: Record<string, unknown>): string[] {
  const collect = (node: unknown): string[] => {
    if (!node || typeof node !== 'object') return [];
    const obj = node as Record<string, unknown>;
    if (typeof obj.message === 'string') return [obj.message];
    return Object.values(obj).flatMap(collect);
  };
  return Object.entries(errors)
    .filter(([k]) => k === 'root' || k.startsWith('root.'))
    .flatMap(([, v]) => collect(v));
}
